// extracted by mini-css-extract-plugin
export var actions = "_3g-0";
export var actionsContainer = "_3g-4";
export var border = "_3g-1";
export var childFullHeight = "_3g-b";
export var collapse = "_3g-2";
export var content = "_3g-6";
export var contentChild = "_3g-a";
export var fullscreen = "_3g-8";
export var hidePadding = "_3g-7";
export var noScrollX = "_3g-c";
export var noScrollY = "_3g-d";
export var optOutTopPadding = "_3g-9";
export var pagePadding = "_3g-5";
export var profile = "_3g-e";
export var profileContainer = "_3g-f";
export var profileImage = "_3g-g";
export var profileMain = "_3g-h";
export var profileSubtitle = "_3g-j";
export var profileTitle = "_3g-i";
export var tabsWrapper = "_3g-3";
export var title = "_3g-k";